/* global window */

export function getError(res) {
    if (!res) {
        return '';
    }

    if (res.error && res.error.error && res.error.error.detail) {
        return res.error.error.detail;
    }
    if (res.error && res.error.error && res.error.error.message) {
        return res.error.error.message;
    }
    else if (res.data && res.data.error && res.data.error.detail) {
        return res.data.error.detail;
    }
    else if (res.error && res.error.data) {
        return res.error.data;
    }
    else if (res.data && res.data.message) {
        return res.data.message;
    }
    else if (res.data && res.data.data) {
        return res.data.data;
    }
    else if (res.data && res.data.errorType) {
        return res.data.errorType;
    }

    return '';
}
// Todo: Remove once we identify the potential errors during runtime
export function modifiedConsole() {
    /**
     * Define a new console to log the warnings
    */
    const console = (oldConsole => {
        return {
            error(msg) {
                if (typeof msg === 'string' && window && window.newrelic && window.newrelic.noticeError) {
                    try {
                        const react_warning = msg.match(/Warning:(.*)./) && msg.match(/Warning:(.*)./)[0] || '';
                        // getting first line of error in react warning

                        window.newrelic.noticeError(new Error(`React ${react_warning} at ${window.location.href} with msg - ${msg} `));
                        oldConsole.log('error -', msg);
                    }
                    catch (e) {
                        window.newrelic.noticeError(new Error(`ModifiedConsole method Error ${e}`));
                    }
                }
                else {
                    oldConsole.log(msg);
                }
            }
        };
    })(window.console);

    // Then redefine the old console
    window.console.error = console.error;
}
